<label [for]="controlId" style="color: black; margin-bottom: 0">{{ controlLabel }} @if (required) {
  <span class="color-red">*</span>
}</label>
